import React from "react";
import Box from "@material-ui/core/Box";
import { FormControl, InputLabel, MenuItem, Select } from "@material-ui/core";

const RuleSetSelect = ({
	ruleSetOptions = [],
	ruleSetId,
	onRuleSelect = () => {}
}) => {
	return (
		<Box style={{ minWidth: "200px" }}>
			<FormControl variant="outlined" fullWidth size="small">
				<InputLabel htmlFor="ruleSet">Rule Set</InputLabel>
				<Select
					value={ruleSetId}
					onChange={onRuleSelect}
					id="ruleSet"
					name="ruleSet"
					label="Rule Set"
				>
					{ruleSetOptions.map((r) => (
						<MenuItem value={r.id} key={r.id}>
							{r.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
};

export default RuleSetSelect;
